import React from "react";
import JoinUsComponent from "../components/JoinUs";
import NavBar from "../components/NavBar";

const Activities = () => {
  return (
    <>
      <NavBar id="register" />
      <JoinUsComponent />
    </>
  );
};

export default Activities;
